module.exports = __webpack_public_path__ + "img/library_video.5d38beea.svg";